<template>
  <div class="_opm">
    <div class="_p" v-if="$store.state.screenWidth > 960">
      <div class="_center">
        <div class="_header">
          <h5>建筑运维管理系统</h5>
          <span>HBIM OPM</span>
        </div>
        <div class="_opm_img_bg">
          <div class="_img" :style="{ backgroundImage: 'url(' + activeImg + ')' }"></div>
        </div>
        <div class="_des">
          <ul>
            <li>以建筑运维为核心</li>
            <li>集成各分类子系统</li>
            <li>建立运维中心数据库</li>
            <li>系统联动、节能优化</li>
          </ul>
          <div class="_btn" @click="$router.push('/product/opm')">
            了解更多
          </div>
        </div>
        <div class="_opm_num"></div>
        <div class="_btm">
          <ul class="_list">
            <li class="_item" v-for="item in imgList" :key="item.id"
              :style="{ backgroundImage: 'url(' + item.small + ')' }" @mouseenter="mouseEnter(item.id)"
              @mouseleave="mouseLeave" :class="active === item.id ? '_active' : ''"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="_m" v-else-if="$store.state.screenWidth <= 960">
      <div class="_header">
        <h5>建筑运维管理系统</h5>
        <span>HBIM OPM</span>
      </div>
      <div class="_info">
        <ul class="_left">
          <li>以建筑运维为核心</li>
          <li>集成各分类子系统</li>
          <li>建立运维中心数据库</li>
          <li>系统联动、节能优化</li>
        </ul>
        <div class="_right">
          <ul class="_left">
            <li>在线项目数<span>10+</span></li>
            <li>空间管理数<span>60000+</span></li>
            <li>工单管理数<span>100000+</span></li>
          </ul>
          <ul class="_right">
            <li>设备接入数<span>70000+</span></li>
            <li>资产管理数<span>200000+</span></li>
          </ul>
        </div>
        <a href="#/product/opm" class="_btn">了解更多</a>
        <!-- <div class="_btn" @click="$router.push('/product/opm')">了解更多</div> -->
      </div>
      <div class="_circle_bg">
        <div class="_bigimg_bg">
          <img :src="mActiveImg" alt="" />
        </div>
      </div>
      <div class="swiper opmSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in imgList" :key="item.id">
            <img :src="item.small" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import bg1 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg1.png";
// import bg2 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg2.png";
// import bg3 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg3.png";
// import bg4 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg4.png";
// import bg5 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg5.png";
// import sm1 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm1.png";
// import sm2 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm2.png";
// import sm3 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm3.png";
// import sm4 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm4.png";
// import sm5 from "https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm5.png";
import Swiper from "swiper"
export default {
  data () {
    return {
      imgList: [
        {
          id: 1,
          small: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm1.png',
          big: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg1.png',
        },
        {
          id: 2,
          small: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm2.png',
          big: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg2.png',
        },
        {
          id: 3,
          small: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm3.png',
          big: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg3.png',
        },
        {
          id: 4,
          small: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm4.png',
          big: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg4.png',
        },
        {
          id: 5,
          small: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/sm5.png',
          big: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg5.png',
        },
      ],
      active: 1,
      activeImg: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg1.png',
      mActiveImg: 'https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm/bg1.png',
      timer: "",
    }
  },
  mounted () {
    const that = this
    this.timer = setInterval(() => {
      this.active++
      this.changeImage(this.active)
      if (this.active > 5) {
        this.active = 1
        this.changeImage(this.active)
      }
    }, 3000)
    // console.log(that.$store.state.screenWidth);
    if (document.body.clientWidth <= 960) {
      this.$nextTick(() => {
        new Swiper(".opmSwiper", {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          autoplay: {
            //自动开始
            delay: 3000, //时间间隔
            disableOnInteraction: false, //*手动操作轮播图后不会暂停*
          },
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          on: {
            transitionEnd: function () {
              // console.log(this.activeIndex, "this.activeIndex");
              that.mActiveImg = that.imgList[this.activeIndex - 3]
                ? that.imgList[this.activeIndex - 3].big
                : that.imgList[0].big
            },
          },
        })
      })
    }
  },
  methods: {
    changeImage (id) {
      this.active = id
      this.imgList.forEach((el) => {
        if (el.id === id) {
          this.activeImg = el.big
        }
      })
    },
    mouseEnter (id) {
      clearInterval(this.timer)
      this.active = id
      this.imgList.forEach((el) => {
        if (el.id === id) {
          this.activeImg = el.big
        }
      })
    },
    mouseLeave () {
      this.timer = setInterval(() => {
        this.active++
        this.changeImage(this.active)
        if (this.active > 5) {
          this.active = 1
          this.changeImage(this.active)
        }
      }, 3000)
    },
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
._opm {
  width: 100%;

  ._p {
    height: 9.37rem;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm_bg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    padding-top: 0.4rem;

    ._center {
      position: relative;
    }

    ._header {
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;

      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }

    ._opm_img_bg {
      width: 7.8rem;
      height: 3.35rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm_img.png") no-repeat;
      background-size: 100% 100%;
      margin: 0.64rem auto 0;
      padding: 0.1px;

      ._img {
        width: 7.44rem;
        height: 2.51rem;
        margin: 0.29rem auto;
        transition: all 0.4s ease-in-out;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    ._des {
      position: absolute;
      top: 0.5rem;
      right: 0;
      width: 2.66rem;
      height: 2.76rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_des.png") no-repeat;
      background-position: center;
      background-size: contain;
      font-size: 0.16rem;
      color: #fff;
      margin-top: 0.63rem;

      ul {
        padding: 0.34rem 0 0 0.75rem;

        li {
          margin-bottom: 0.2rem;
          position: relative;

          &::before {
            position: absolute;
            top: 0;
            left: -0.25rem;
            content: "";
            display: block;
            width: 0.19rem;
            height: 0.19rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/lvp_circle.png") no-repeat;
            background-position: center;
            background-size: contain;
          }
        }
      }

      ._btn {
        width: 1rem;
        height: 0.32rem;
        line-height: 0.32rem;
        text-align: center;
        margin: 0 auto;
        background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
          linear-gradient(#3660aa, #3660aa);
        cursor: pointer;
      }
    }

    ._opm_num {
      width: 10.78rem;
      height: 0.86rem;
      margin: 1.1rem auto 0;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/opm_num.png");
      background-size: contain;
    }

    ._btm {
      position: absolute;
      top: 7rem;
      width: 100%;

      ._list {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 1.66rem;

        ._item {
          width: 2.39rem;
          height: 1.35rem;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          cursor: pointer;
          transition: all 0.4s ease-in-out;
        }

        ._active {
          width: 2.94rem;
          height: 1.66rem;
        }
      }
    }
  }

  ._m {
    position: relative;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_09.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    padding: 0.3rem 0.26rem 2.72rem;

    ._header {
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;

      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }

    ._info {
      position: relative;
      width: 6.96rem;
      // height: 1.67rem;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_05.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      display: flex;
      padding: 0.51rem 0.36rem 0.3rem 0.47rem;

      >._left {
        margin-right: 0.6rem;

        li {
          position: relative;
          font-size: 0.16rem;
          letter-spacing: 0.008rem;
          color: #ffffff;
          margin-bottom: 0.1rem;

          &::before {
            position: absolute;
            left: -0.2rem;
            top: 0;
            content: "";
            display: block;
            width: 0.17rem;
            height: 0.17rem;
            background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_06.png") no-repeat;
            background-size: contain;
            background-position: center;
          }
        }
      }

      >._right {
        display: flex;

        ul {
          li {
            font-size: 0.16rem;
            letter-spacing: 0rem;
            color: #ffffff;
            margin-bottom: 0.2rem;

            span {
              font-size: 0.2rem;
              font-weight: bold;
              font-style: italic;
              font-stretch: normal;
              color: #ecc800;
            }
          }
        }

        ._left {
          margin-right: 0.2rem;
        }
      }

      ._btn {
        position: absolute;
        right: 0.3rem;
        bottom: 0.25rem;
        width: 1.01rem;
        height: 0.33rem;
        line-height: 0.33rem;
        background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
          linear-gradient(#3660aa, #3660aa);
        background-blend-mode: normal, normal;
        border-radius: 0.02rem;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.16rem;
        text-align: center;
      }
    }

    ._circle_bg {
      position: relative;
      width: 100%;
      height: 3.84rem;
      // background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_07.png") no-repeat;
      background-size: contain;
      background-position: center;
      margin-top: 1.05rem;

      ._bigimg_bg {
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 6.51rem;
        height: 3.87rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_10.png") no-repeat;
        background-size: contain;
        background-position: center;
        text-align: center;

        img {
          width: 6.19rem;
          height: 2.09rem;
          margin-top: 0.85rem;
        }
      }
    }

    .opmSwiper {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: -3rem;
      left: 0;
      overflow: hidden;

      .swiper-wrapper {
        .swiper-slide {
          text-align: center;
          font-size: 18px;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          transition: 300ms;
          transform: scale(0.8);
        }

        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
          z-index: 99;

          img {
            box-shadow: 0rem 0.05rem 0.205rem 0.045rem rgba(3, 70, 143, 0.48);
            border: solid 0.02rem #4165af;
          }
        }
      }
    }
  }
}</style>


// WEBPACK FOOTER //
// src/components/Index/Opm.vue